const urlGenerator = {
  categoryLink: function (slug) {
    return `/${slug}`;
  },
  categoryDir: function () {
    return "/[categorySlug]";
  },
  faqLink: function (categorySlug, faqSlug) {
    return `/${categorySlug}/${faqSlug}`;
  },
  faqDir: function () {
    return "/[categorySlug]/[faqSlug]";
  },
};

export default urlGenerator;
